import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userpermissions: [],
  userpermission: {
    id: 0,
    userId: 0,
    permissionId: 0,
    permissions: [],
  }
};

const userpermissionSlice = createSlice({
  name: "userpermission",
  initialState,
  reducers: {
    restartState(state) {
      state.userpermission = {};
      state.userpermissions = [];
    },
    setUserpermissions(state, actions) {
      state.userpermissions = actions.payload.userpermissions;
      state.userpermission = {};
    },
    setUserpermission(state, actions) {
      state.userpermission = actions.payload.userpermission;
      state.userpermissions = [];
    },
    modifyPropertyValue(state, actions) {
      state.userpermission[actions.payload.id] = actions.payload.value;
    },
    setUserpermissionValidation(state, actions) {
      state.userpermissionValidation = {
        userid: {
          ...state.userpermissionValidation.userid,
          isValid: actions.payload.userid !== "",
        },
        permissionid: {
          ...state.userpermissionValidation.permissionid,
          isValid: actions.payload.permissionid !== "",
        },
        permissions: {
          ...state.userpermissionValidation.permissions,
          isValid: actions.payload.permissions !== "",
        },
      };
      state.userpermissionValidation.isValid =
        state.userpermissionValidation.userId.isValid;
    },
    setFieldValid(state, actions) {
      state.userpermissionValidation[actions.payload.id].isValid = actions.payload.value;
    },
  },
});

export const userpermissionActions = userpermissionSlice.actions;
export default userpermissionSlice;
